export default function PhotoUpload() {
  return (
    <div className="screen container">
      <h1>C4: Photo Upload</h1>
      <p style={{ color: 'var(--color-text-secondary)', marginTop: '8px' }}>
        Upload photos of food, symptoms, or progress.
      </p>
      <div className="card" style={{ marginTop: '24px', textAlign: 'center', color: 'var(--color-text-muted)' }}>
        Coming soon — this screen will be built in Phase 2.
      </div>
    </div>
  );
}
